<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="background-color: white;padding-bottom: 10px;padding-right: 10px">
            <el-form ref="form" :model="form" label-width="80px">
                <!--第一行搜索-->
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="采购单号: " label-width="120px">
                            <el-input v-model="form.name" class="in" placeholder="多个采购单号用逗号隔开" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="供应商：" label-width="120px">
                            <el-input v-model="form.name" class="in" placeholder="请输入供应商名称，多个供应商用逗号隔开" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="本地SKU：" label-width="120px">
                            <el-input v-model="form.name" class="in" placeholder="请输入本地SKU，多个本地SKU用逗号隔开" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--第二行搜索-->
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="产品名称：" label-width="120px">
                            <el-input v-model="form.name" class="in" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="1688订单号: " label-width="120px">
                            <el-input v-model="form.name" class="in" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="运单号：" label-width="120px">
                            <el-input v-model="form.name" class="in" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="text-align: right;">
                    <el-button type="info" size="small">
                        重置
                    </el-button>
                    <el-button type="primary" size="small">
                        搜索
                    </el-button>
                </el-row>
            </el-form>
        </div>
        <!--按钮组-->
        <div style="margin-top: 20px">
            <el-row>
                <el-button type="success" @click="diaLog.dcDialogVisible=true" size="small">导出</el-button>
            </el-row>
        </div>
        <!--table-->
        <div style="margin-top: 20px;margin-bottom:20px;background-color: white;padding: 10px 20px 10px 20px">
            <div style="background-color: white">
                <div style="background-color: #eef1f6;border-bottom: 1px solid #DCDFE6;">
                    <el-row>
                        <el-col :span="8">PO8M9Z000001</el-col>
                        <el-col :span="8" style="text-align: center">供货商： 肃宁县翔锐渔具厂</el-col>
                        <el-col :span="8" style="text-align: right"> 仓库：默认仓库 | 采购员：husiyang</el-col>
                    </el-row>
                </div>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                    <el-table-column
                            prop="name"
                            label="商品信息">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="付款金额">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="1688订单号">
                    </el-table-column>
                    <el-table-column
                            prop="ydh"
                            label="运单号">
                        <template slot-scope="scope">
                            <el-button type="text" @click="diaLog.ddhDialogVisible = true">添加订单号</el-button>
                            <br>
                            <span>asdasdas</span><br>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="时间">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="状态">
                    </el-table-column>
                    <el-table-column prop="handel" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="submitSh">通过审核</el-button>
                            </br>
                            <el-button type="text" size="mini" style="margin-top: 2px" @click="bhSh">驳回审核
                            </el-button>
                            </br>
                        </template>
                    </el-table-column>
                </el-table>
                <template>
                    <div class="block" style="text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page.currentPage1"
                                :page-size="100"
                                layout="total, prev, pager, next"
                                :total="1000">
                        </el-pagination>
                    </div>
                </template>
            </div>

        </div>
        <!--添加订单号diaLog-->
        <el-dialog :close-on-click-modal="false"   class="head"
                   title="添加订单号"
                   :visible.sync="diaLog.ddhDialogVisible"
                   width="80%"
                >
            <!--表格-->
            <div>
                <template>
                    <el-table
                            border
                            :data="ddhtableData"
                            style="width: 100%"
                            :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                        <el-table-column
                                prop="date"
                                label="采购订单">
                        </el-table-column>
                        <el-table-column style="color: red"
                                         prop="name"
                                         label="付款金额[采购仓库]">
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                label="采购金额">
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                label="选择物流商">
                            <template slot-scope="scope">
                                <el-select clearable  v-model="yys.value1" placeholder="请选择">
                                    <el-option
                                            v-for="item in options1"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-select clearable  v-model="yys.value2" placeholder="请选择">
                                    <el-option
                                            v-for="item in options2"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                label="运单号"
                                width="300px">
                            <template slot-scope="scope">
                                <el-row>
                                    <el-input v-model="yys.input1" placeholder="请输入内容"
                                              style="width: 230px;margin-right: 20px"></el-input>
                                    <i class="el-icon-circle-plus" @click="add(scope.$index)"></i>
                                </el-row>
                                <el-row>
                                    <div v-for="(item, i) in ddhtableData[0].dt" :key="i">
                                        <el-input v-model="item.ddh" placeholder="请输入内容"
                                                  style="width: 230px;margin-right: 20px"></el-input>
                                        <i class="el-icon-remove" @click="deletei(i)"></i>
                                    </div>
                                </el-row>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="diaLog.ddhDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="diaLog.ddhDialogVisible = false">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 导出弹出框 -->
        <el-dialog :close-on-click-modal="false"  
                title="导出图片"
                :visible.sync="diaLog.dcDialogVisible"
                width="30%">
            <span>已导出:<font style="color: red">XX</font></span><br>
            <span>导出文件已生成，请立即下载！</span><br>
            <div>
                <el-progress :text-inside="true" :stroke-width="24" :percentage="100" status="success"></el-progress>
            </div>
            <span slot="footer" class="dialog-footer">
                  <el-button @click="diaLog.dcDialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="diaLog.dcDialogVisible = false">下 载</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                form: {
                    name: '',
                    ydh: '',
                    sort: ''
                },
                page: {
                    currentPage1: 5,
                },
                diaLog: {
                    ddhDialogVisible: false,
                    dcDialogVisible:false
                },
                tableData: [{
                    date: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3809745961,2192250962&fm=26&gp=0.jpg',
                    name: '1111',
                    address: '2020-09-01',
                    dt: []
                }, {
                    date: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3809745961,2192250962&fm=26&gp=0.jpg',
                    name: '1111',
                    address: '2020-09-01',
                    dt: []
                }, {
                    date: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3809745961,2192250962&fm=26&gp=0.jpg',
                    name: '1111',
                    address: '2020-09-01',
                    dt: []
                }, {
                    date: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3809745961,2192250962&fm=26&gp=0.jpg',
                    name: '1111',
                    address: '2020-09-01',
                    dt: []
                }],
                // 订单表格
                ddhtableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄',
                    dt: []
                }],
                //运营商选择
                options1: [{
                    value: '选项1',
                    label: '天天'
                }, {
                    value: '选项2',
                    label: '韵达'
                }, {
                    value: '选项3',
                    label: '申通'
                }, {
                    value: '选项4',
                    label: '圆通'
                }],
                options2: [{
                    value: '选项1',
                    label: '天天'
                }, {
                    value: '选项2',
                    label: '韵达'
                }, {
                    value: '选项3',
                    label: '申通'
                }, {
                    value: '选项4',
                    label: '圆通'
                }],
                yys: {
                    value1: '',
                    value2: '',
                    input1: '',
                    input2: ''
                }
            };
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            add(index) {
                this.ddhtableData[index].dt.push({
                    ddh: ''
                });
            },
            deletei(index) {
                //获取每个输入框的值
                // alert(this.ddhtableData[0].dt[index].ddh)
                this.ddhtableData[0].dt.splice(index, 1)
            },
            //提交审核
            submitSh() {
                this.$confirm('此操作将提交审核, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '审核成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '审核失败'
                    });
                });
            },
            //提交审核
            bhSh() {
                this.$confirm('此操作将驳回审核, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '驳回审核成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '驳回审核失败'
                    });
                });
            },
        }
    }
</script>

<style>
    .in {
        width: 250px;
    }
    .head .el-dialog__header {
        background-color: #eef1f6;
    }
</style>
